import { useOrderAdjustmentIndex } from 'pages/OrderAdjustments/hooks/useOrderAdjustmentIndex';
import { OrderAdjustmentsOrder } from 'pages/OrderAdjustments/types';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useFormContext } from 'react-hook-form';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { NumberInput } from 'shared/react-admin/Inputs';

import { StyledBox, StyledDialog } from './OrderAdjustmentsAmountDialog.styled';

type Props = DialogProps & {
  record: OrderAdjustmentsOrder;
};

export const OrderAdjustmentsAmountDialog = ({ record, open, onClose }: Props) => {
  const translate = useTypedTranslate();
  const { setValue } = useFormContext();
  const recordIndex = useOrderAdjustmentIndex(record.id);

  return (
    <StyledDialog maxWidth="md" onClose={onClose} open={open}>
      <StyledBox>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title={translate('app.orderAdjustments.dialogs.amount.title')}
          titleSize="smallBold"
        />
        <CardContent>
          <NumberInput
            fullWidth
            label={translate('app.orderAdjustments.datagrid.amount')}
            multiline
            required
            size="small"
            source={`orderAdjustments.${recordIndex}.newAmount`}
            variant="outlined"
          />
        </CardContent>
        <CardActionsButtons
          leftActionsSlot={[
            <Button
              key="clear-button"
              label={translate('app.orderAdjustments.dialogs.amount.clear')}
              onClick={() => setValue(`orderAdjustments.${recordIndex}.newAmount`, null)}
              type="button"
              variant="outlined"
            />,
          ]}
          rightActionsSlot={[
            <CancelButton key="cancel-button" onClick={onClose} variant="outlined" />,
            <Button
              key="save-button"
              label={translate('app.buttons.apply')}
              onClick={onClose}
              type="button"
              variant="contained"
            />,
          ]}
        />
      </StyledBox>
    </StyledDialog>
  );
};
